import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useGetTablesdataMutation } from "./TablesourceApiSlice";
import { useGetPostgresqlTablesColumndataMutation } from "./sqlApiSlice";

const TableSource = ({
  setNickName,
  connectionId,
  selectedTable,
  nickName,
}) => {
  const location = useLocation();
  const databaseType = location?.state?.dbType;
  // console.log(databaseType);

  const [getTablesdata, { data, isLoading, isError, isSuccess }] =
    useGetTablesdataMutation();
  const [
    getTablesdatasqlalchemy,
    {
      data: datapg,
      isLoading: isLoadingpg,
      isError: isErrorpg,
      isSuccess: isSuccesspg,
    },
  ] = useGetPostgresqlTablesColumndataMutation();
  // console.log(data, datapg);

  const [input, setInput] = useState(selectedTable);

  // Fetch data based on database type
  useEffect(() => {
    if (connectionId && selectedTable) {
      const timer = setTimeout(() => {
        if (databaseType === "postgresql") {
          getTablesdatasqlalchemy({ tableName: selectedTable, connectionId });
        } else if (databaseType === "mysql") {
          getTablesdata({ selectedTable, connectionId });
        }
      }, 300);

      return () => clearTimeout(timer);
    }
  }, [selectedTable, connectionId, databaseType]);

  // Set initial nickname for PostgreSQL
  useEffect(() => {
    if (databaseType === "postgresql" && datapg?.table) {
      setInput(datapg.table);
      setNickName(datapg.table);
    } else if (databaseType === "mysql" && selectedTable) {
      setInput(selectedTable);
      setNickName(selectedTable);
    }
  }, [datapg, data, selectedTable, databaseType, setNickName]);

  const handleInputChange = (e) => {
    setInput(e.target.value);
    setNickName(e.target.value);
  };

  // Conditional rendering
  let tableContent;

  if (isLoading || isLoadingpg) {
    tableContent = <p>Loading...</p>;
  } else if (isError || isErrorpg) {
    const errorMessage =
      isErrorpg?.data?.message ??
      isErrorpg?.error ??
      isError?.data?.message ??
      isError?.error;

    tableContent = <p className="text-red-500">{errorMessage}</p>;
  } else if (
    databaseType === "postgresql" &&
    isSuccesspg &&
    Array.isArray(datapg?.columns)
  ) {
    // PostgreSQL rendering
    tableContent = (
      <section className="flex flex-col gap-2 h-[40rem] lg:h-full w-full lg:w-[30%]">
        <div className="flex w-full items-center justify-start">
          <label className="font-medium mr-2">Table Name:</label>
          <input
            type="text"
            placeholder="Enter table nickname"
            className="border-b border-gray-200 rounded pl-1 outline-none text-blue-950"
            value={input}
            onChange={handleInputChange}
          />
        </div>

        <table className="border border-gray-300 border-collapse w-full text-sm">
          <thead className="sticky top-0 bg-gray-200 mb-[2px]">
            <tr>
              <th className="border border-gray-300 text-left px-1 text-blue-950 font-bold">
                Column Name
              </th>
              <th className="border border-gray-300 text-left px-1 text-blue-950 font-bold">
                Data Type
              </th>
            </tr>
          </thead>
          <tbody className="overflow-auto">
            {datapg.columns.map((column, index) => (
              <tr
                key={index}
                className={`border-none ${index % 2 === 0 ? "bg-gray-100" : "bg-white"
                  }`}
              >
                <td className="border border-gray-300 text-left pl-1">
                  {column.name}
                </td>
                <td className="border border-gray-300 text-left pl-1">
                  {column.datatype}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>
    );
  } else if (
    databaseType === "mysql" &&
    isSuccess &&
    Array.isArray(data?.mappedColumnArray)
  ) {
    // MySQL/Generic DB rendering
    const { mappedColumnArray } = data;

    tableContent = (
      <section className="flex flex-col gap-2 h-[40rem] lg:h-full w-full lg:w-[30%]">
        <div className="flex w-full items-center justify-start">
          <label className="font-medium">Table Name:</label>
          <input
            type="text"
            placeholder="Enter value"
            className="border-b border-gray-200 rounded pl-1 outline-none text-blue-950"
            value={input}
            onChange={handleInputChange}
          />
        </div>

        <table className="border border-gray-300 border-collapse w-full text-sm">
          <thead className="sticky top-0 bg-gray-200 mb-[2px]">
            <tr>
              <th className="border border-gray-300 text-left px-1 text-blue-950 font-bold">
                Column Name
              </th>
              <th className="border border-gray-300 text-left px-1 text-blue-950 font-bold">
                Data Type
              </th>
            </tr>
          </thead>
          <tbody className="overflow-auto">
            {mappedColumnArray.map((column, index) => (
              <tr
                key={index}
                className={`border-none ${index % 2 === 0 ? "bg-gray-100" : "bg-white"
                  }`}
              >
                <td className="border border-gray-300 text-left pl-1">
                  {column.rename}
                </td>
                <td className="border border-gray-300 text-left pl-1">
                  {column.dataType}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>
    );
  } else {
    tableContent = <p>No columns found in the selected table.</p>;
  }

  return <>{tableContent}</>;
};

export default TableSource;
